module.exports = __webpack_public_path__ + "static/media/KUDOS TITAN 606 SPEAKERS.83b6e252.png";